"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Wrapper) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(FlipMotion, _Component);

    function FlipMotion() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, FlipMotion);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FlipMotion.__proto__ || Object.getPrototypeOf(FlipMotion)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        height: 0,
        isAnimatingHeight: false,
        shouldMeasure: false,
        previousChildren: null,
        previousPosition: null,
        transform: null,
        unmountingElements: null
      }, _this.children = {}, _this.newHeight = 0, _this.getTransform = function (_ref2) {
        var scaleX = _ref2.scaleX,
            scaleY = _ref2.scaleY,
            x = _ref2.x,
            y = _ref2.y;

        if (x === 0 && y === 0 && scaleX === 1 && scaleY === 1) return {};

        var transformString = "translate(" + x + "px, " + y + "px) scaleX(" + scaleX + ") scaleY(" + scaleY + ")";

        return {
          transform: transformString,
          WebkitTransform: transformString
        };
      }, _this.willEnter = function () {
        return {
          x: 0,
          y: 0,
          scaleX: _this.props.scaleX,
          scaleY: _this.props.scaleY,
          opacity: 0
        };
      }, _this.onHeightAnimationRest = function () {
        _this.setState({ isAnimatingHeight: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FlipMotion, [{
      key: "getStyles",
      value: function getStyles() {
        var _this2 = this;

        var _state = this.state,
            shouldMeasure = _state.shouldMeasure,
            unmountingElements = _state.unmountingElements;
        var _props = this.props,
            scaleX = _props.scaleX,
            scaleY = _props.scaleY,
            springConfig = _props.springConfig;

        // If some elements are unmounting, use previousChildren to be able to add out transition to leaving elements

        var children = unmountingElements && Object.keys(unmountingElements).length ? this.state.previousChildren : this.props.children;

        return _react.Children.map(children, function (child) {
          return {
            data: child,
            style: unmountingElements && unmountingElements[child.key] ? {
              x: 0,
              y: 0,
              opacity: shouldMeasure ? 1 : (0, _reactMotion.spring)(0, springConfig),
              scaleX: shouldMeasure ? 1 : (0, _reactMotion.spring)(scaleX, springConfig),
              scaleY: shouldMeasure ? 1 : (0, _reactMotion.spring)(scaleY, springConfig)
            } : _extends({
              x: (0, _reactMotion.spring)(0, springConfig),
              y: (0, _reactMotion.spring)(0, springConfig)
            }, _this2.state.transform && _this2.state.transform[child.key] ? _this2.state.transform[child.key] : null, {
              opacity: (0, _reactMotion.spring)(1, springConfig),
              scaleX: (0, _reactMotion.spring)(1, springConfig),
              scaleY: (0, _reactMotion.spring)(1, springConfig)
            }),
            key: child.key
          };
        });
      }
    }, {
      key: "pruneUnmountingElements",
      value: function pruneUnmountingElements() {
        var _this3 = this;

        // Remove elements that have completed their out transition
        var prunedUnmountingElements = {};

        Object.keys(this.state.unmountingElements || {}).forEach(function (key) {
          var childEl = _this3.children[key];
          if (childEl && parseFloat(childEl.style.opacity) !== 0) {
            prunedUnmountingElements[key] = _this3.state.unmountingElements[key];
          }
        });

        if (!Object.keys(prunedUnmountingElements).length) {
          clearInterval(this.pruneLoop);
        }

        this.setState({ unmountingElements: prunedUnmountingElements });
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this4 = this;

        var prevChildren = _react.Children.toArray(prevProps.children);
        var nextChildren = _react.Children.toArray(this.props.children);
        var hasSameChildren = prevChildren.length === nextChildren.length && nextChildren.every(function (item, index) {
          return item.key === prevChildren[index].key;
        });

        if (hasSameChildren) {
          return;
        }

        var containerHeight = (0, _reactDom.findDOMNode)(this).offsetHeight;
        var unmountingElements = {};
        var nextKeys = _react.Children.map(this.props.children, function (child) {
          return child.key;
        });
        var parentRect = (0, _reactDom.findDOMNode)(this).getBoundingClientRect();

        _react.Children.forEach(prevProps.children, function (prevChild, index) {
          // If key is missing in nextKeys element is about to unmount. Store dimensions to be able to position absolutely
          if (nextKeys.indexOf(prevChild.key) === -1) {
            var child = _this4.children[prevChild.key];
            var rect = child ? child.getBoundingClientRect() : { top: parentRect.top, left: parentRect.left };

            unmountingElements[prevChild.key] = {
              index: index,
              styles: {
                height: rect.height,
                width: rect.width,
                left: rect.left - parentRect.left,
                top: rect.top - parentRect.top,
                position: "absolute",
                zIndex: 0
              }
            };
          }
        });

        // Combine nextProps.children with unmounting elements to keep them mounted so they can be animated out
        var previousChildren = [].concat(this.props.children, Object.values(unmountingElements).map(function (element) {
          return prevProps.children[element.index];
        }));

        // As TransitionMotion does not provide a callback for motion end, we need to manually remove the elements that have completed their out transition and are ready to be unmounted
        clearInterval(this.pruneLoop);
        this.pruneLoop = setInterval(this.pruneUnmountingElements.bind(this), 100);

        this.setState({
          unmountingElements: unmountingElements,
          shouldMeasure: true,
          previousChildren: previousChildren,
          previousPosition: Object.entries(this.children).reduce(function (acc, _ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                key = _ref4[0],
                child = _ref4[1];

            return Object.assign(acc, child ? _defineProperty({}, key, child.getBoundingClientRect()) : {});
          }, {}),
          transform: null
        }, function () {
          _raf2.default.cancel(_this4.raf);
          _this4.raf = (0, _raf2.default)(function () {
            _this4.setState(function (state) {
              _this4.newHeight = (0, _reactDom.findDOMNode)(_this4).offsetHeight;
              return {
                height: containerHeight,
                shouldMeasure: false,
                transform: Object.entries(_this4.children).reduce(function (acc, _ref6) {
                  var _ref7 = _slicedToArray(_ref6, 2),
                      key = _ref7[0],
                      child = _ref7[1];

                  var previousRect = state.previousPosition[key];
                  var childRect = child && child.getBoundingClientRect();
                  return Object.assign({}, acc, _defineProperty({}, key, childRect && previousRect ? {
                    x: previousRect.left - childRect.left,
                    y: previousRect.top - childRect.top
                  } : { x: 0, y: 0 }));
                }, {}),
                previousPosition: null
              };
            }, function () {
              if (_this4.state.transform) {
                _this4.setState(function (state) {
                  return {
                    height: (0, _reactMotion.spring)(_this4.newHeight, _this4.props.springConfig),
                    isAnimatingHeight: true,
                    transform: Object.keys(state.transform).reduce(function (acc, key) {
                      return Object.assign({}, acc, _defineProperty({}, key, {
                        x: (0, _reactMotion.spring)(0, _this4.props.springConfig),
                        y: (0, _reactMotion.spring)(0, _this4.props.springConfig)
                      }));
                    }, {})
                  };
                });
                _this4.children = {};
              }
            });
          });
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _raf2.default.cancel(this.raf);
        clearInterval(this.pruneLoop);
      }
    }, {
      key: "render",
      value: function render() {
        var _this5 = this;

        var _props2 = this.props,
            style = _props2.style,
            childStyle = _props2.childStyle;
        var _state2 = this.state,
            isAnimatingHeight = _state2.isAnimatingHeight,
            shouldMeasure = _state2.shouldMeasure;

        var Component = this.props.component;
        var ChildComponent = this.props.childComponent;
        var unmountingElements = this.state.unmountingElements || {};
        var hasUnmountingElements = Object.keys(unmountingElements).length;

        return _react2.default.createElement(
          Wrapper,
          { height: this.state.height, onRest: this.onHeightAnimationRest },
          function (_ref8) {
            var height = _ref8.height;
            return _react2.default.createElement(
              _reactMotion.TransitionMotion,
              {
                styles: _this5.getStyles(),
                willEnter: _this5.willEnter
              },
              function (styles) {
                return _react2.default.createElement(
                  Component,
                  {
                    style: _extends({}, style, {
                      height: shouldMeasure || !isAnimatingHeight ? "auto" : height,
                      position: "relative"
                    }),
                    className: _this5.props.className
                  },
                  styles.map(function (item) {
                    var willUnmount = shouldMeasure && unmountingElements[item.key];
                    var unMountingStyles = unmountingElements[item.key] && unmountingElements[item.key].styles;

                    return _react2.default.createElement(
                      ChildComponent,
                      {
                        className: _this5.props.childClassName,
                        key: item.key,
                        style: item.style && _extends({}, childStyle, hasUnmountingElements ? {
                          position: "relative",
                          zIndex: 1
                        } : {}, unMountingStyles, _this5.getTransform(item.style), {
                          display: willUnmount ? "none" : childStyle.display,
                          opacity: item.style.opacity
                        }),
                        ref: function ref(c) {
                          return _this5.children[item.key] = c;
                        }
                      },
                      item.data
                    );
                  })
                );
              }
            );
          }
        );
      }
    }]);

    return FlipMotion;
  }(_react.Component), _class.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
    childClassName: _propTypes2.default.string,
    childComponent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
    childStyle: _propTypes2.default.object,
    className: _propTypes2.default.string,
    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
    scaleX: _propTypes2.default.number,
    scaleY: _propTypes2.default.number,
    springConfig: _propTypes2.default.shape({
      stiffness: _propTypes2.default.number,
      damping: _propTypes2.default.number,
      precision: _propTypes2.default.number
    }),
    style: _propTypes2.default.object
  }, _class.defaultProps = {
    animateWrapper: true,
    childStyle: {},
    component: "div",
    childComponent: "div",
    scaleX: 0.6,
    scaleY: 0.6
  }, _temp2;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _raf = require("raf");

var _raf2 = _interopRequireDefault(_raf);

var _reactMotion = require("react-motion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }